import { createFileRoute, redirect } from "@tanstack/react-router";

// Deleting a retailer now lives at the bottom of General.
export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/danger-zone",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/$organizationSlug/settings/general",
			params: { organizationSlug: params.organizationSlug },
		});
	},
});
